export default "__VITE_ASSET__bcc78bda__"